/* This file is autogenerated, see readme.md for instructions */
import PinSvgIcon from '@bloomreach/banana-theme/icons/pin.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PinIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PinSvgIcon />
    </Icon>
  );
});

PinIcon.displayName = 'PinIcon';

export default PinIcon;
